"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOOL_BAR_VIEW_SETTING = exports.ORG_CHART_RECORD_LIST = exports.GANTT_CONFIG_COLOR_HELP = exports.FORM_CONTAINER_SETTING = exports.ADD_RECORD_BTN = exports.APPLICATION_JOIN_SPACE_BTN = exports.CREATE_ORG_IN_VIEW_LIST = exports.CREATE_CALENDAR_IN_VIEW_LIST = exports.VIEW_LIST_CREATE_GANTT_VIEW = exports.VIEW_LIST_CREATE_GALLERY_VIEW = exports.VIEW_LIST_CREATE_KANBAN_VIEW = exports.VIEW_LIST_CREATE_GRID_VIEW = exports.VIEW_LIST_SHOW_BTN = exports.VIEW_OPERATION_ITEM_CHANGE_AUTO_SAVE_CHECK = exports.VIEW_OPERATION_ITEM_CHANGE_AUTO_SAVE = exports.VIEW_OPERATION_ITEM_LOCK_CHECK = exports.VIEW_OPERATION_ITEM_LOCK = exports.VIEW_OPERATION_ITEM_DELETE = exports.VIEW_OPERATION_ITEM_EXPORT_VIEW_TO_IMAGE = exports.VIEW_OPERATION_ITEM_EXPORT_VIEW_TO_EXCEL = exports.VIEW_OPERATION_ITEM_EXPORT_VIEW_TO_CSV = exports.VIEW_OPERATION_ITEM_COPY_MIRROR = exports.VIEW_OPERATION_ITEM_COPY_FORM = exports.VIEW_OPERATION_ITEM_COPY = exports.VIEW_OPERATION_ITEM_RENAME = exports.VIEW_CREATOR_TABLE = exports.VIEW_CREATOR_GANTT = exports.VIEW_CREATOR_ORG_CHART = exports.VIEW_CREATOR_CALENDAR = exports.VIEW_CREATOR_FORM = exports.VIEW_CREATOR_GRID = exports.VIEW_CREATOR_GALLERY = exports.VIEW_CREATOR_KANBAN = exports.ADD_COLUMN_BTN = exports.DOM_CONTAINER = exports.TIME_MACHINE_BTN = exports.FORM_LIST_PANEL = exports.ROBOT_BTN = exports.WIDGET_BTN = exports.FORM_BTN = exports.API_BTN = exports.VIEW_TAB_BAR = exports.VIKABY = exports.FILL_HANDLE_AREA = exports.GRID_CUR_COLUMN_TYPE = exports.SWITCH_VIEW_TYPE_CONTAINER = exports.VIEW_TOOL_BAR = exports.FIELD_CONTEXT = exports.ADD_VIEW_BTN = exports.VIEW_EXPORT = void 0;
exports.SIDE_RECORD_PANEL = void 0;
/* eslint-disable */
// The id of the datasheet (parts of, excluding the working directory)
const PREFIX = 'DATASHEET_';
exports.VIEW_EXPORT = PREFIX + 'VIEW_EXPORT'; // view export
exports.ADD_VIEW_BTN = PREFIX + 'ADD_VIEW_BTN'; // New view icon button
exports.FIELD_CONTEXT = PREFIX + 'FIELD_CONTEXT'; // Right-click menu of the Wig table header
exports.VIEW_TOOL_BAR = PREFIX + 'TOOL_BAR'; // view toolbar
exports.SWITCH_VIEW_TYPE_CONTAINER = PREFIX + 'SWITCH_VIEW_TYPE_CONTAINER'; // create a new view card
exports.GRID_CUR_COLUMN_TYPE = PREFIX + 'GRID_CUR_COLUMN_TYPE';
exports.FILL_HANDLE_AREA = PREFIX + 'FILL_HANDLE_AREA';
exports.VIKABY = PREFIX + 'VIKABY'; // vikaby
// view tab bar
exports.VIEW_TAB_BAR = PREFIX + 'VIEW_TAB_BAR'; // view tab bar
exports.API_BTN = PREFIX + 'API_BTN'; // view tab bar - api panel
exports.FORM_BTN = PREFIX + 'FORM_BTN'; // View Tab Bar - Magic Form
exports.WIDGET_BTN = PREFIX + 'WIDGET_BTN'; // View Tab Bar - Widget
exports.ROBOT_BTN = PREFIX + 'ROBOT_BTN'; // View Tab Bar - Robot
exports.FORM_LIST_PANEL = PREFIX + 'FORM_LIST_PANEL'; // view tab bar - magic form list
exports.TIME_MACHINE_BTN = PREFIX + 'TIME_MACHINE_BTN'; // View Tab Bar - Time Machine
// Wig table content (Wig view)
exports.DOM_CONTAINER = PREFIX + 'DOM_CONTAINER'; // Wig table content (Wig view)
exports.ADD_COLUMN_BTN = PREFIX + 'ADD_COLUMN_BTN'; // New column button
// create a new view context
exports.VIEW_CREATOR_KANBAN = PREFIX + 'CREATE_KANBAN_VIEW';
exports.VIEW_CREATOR_GALLERY = PREFIX + 'CREATE_GALLERY_VIEW';
exports.VIEW_CREATOR_GRID = PREFIX + 'CREATE_GRID_VIEW';
exports.VIEW_CREATOR_FORM = PREFIX + 'CREATE_FORM_VIEW';
exports.VIEW_CREATOR_CALENDAR = PREFIX + 'CREATE_CALENDAR_VIEW';
exports.VIEW_CREATOR_ORG_CHART = PREFIX + 'CREATOR_ORG_CHART';
exports.VIEW_CREATOR_GANTT = PREFIX + 'CREATE_GANTT_VIEW';
exports.VIEW_CREATOR_TABLE = PREFIX + 'CREATE_TABLE';
// view operation context
exports.VIEW_OPERATION_ITEM_RENAME = PREFIX + 'RENAME_VIEW';
exports.VIEW_OPERATION_ITEM_COPY = PREFIX + 'COPY_VIEW';
exports.VIEW_OPERATION_ITEM_COPY_FORM = PREFIX + 'COPY_VIEW_FORM';
exports.VIEW_OPERATION_ITEM_COPY_MIRROR = PREFIX + 'COPY_VIEW_MIRROR';
exports.VIEW_OPERATION_ITEM_EXPORT_VIEW_TO_CSV = PREFIX + 'EXPORT_VIEW_CSV';
exports.VIEW_OPERATION_ITEM_EXPORT_VIEW_TO_EXCEL = PREFIX + 'EXPORT_VIEW_EXCEL';
exports.VIEW_OPERATION_ITEM_EXPORT_VIEW_TO_IMAGE = PREFIX + 'EXPORT_VIEW_IMAGE';
exports.VIEW_OPERATION_ITEM_DELETE = PREFIX + 'DELETE_VIEW';
exports.VIEW_OPERATION_ITEM_LOCK = PREFIX + 'LOCK_VIEW';
exports.VIEW_OPERATION_ITEM_LOCK_CHECK = PREFIX + 'LOCK_VIEW_CHECK';
exports.VIEW_OPERATION_ITEM_CHANGE_AUTO_SAVE = PREFIX + 'CHANGE_AUTO_SAVE';
exports.VIEW_OPERATION_ITEM_CHANGE_AUTO_SAVE_CHECK = PREFIX + 'CHANGE_AUTO_SAVE_CHECK';
// view list view button
exports.VIEW_LIST_SHOW_BTN = PREFIX + 'SHOW_VIEW_LIST_BTN';
// view list context
exports.VIEW_LIST_CREATE_GRID_VIEW = PREFIX + 'CREATE_GRID_IN_VIEW_LIST';
exports.VIEW_LIST_CREATE_KANBAN_VIEW = PREFIX + 'CREATE_KANBAN_IN_VIEW_LIST';
exports.VIEW_LIST_CREATE_GALLERY_VIEW = PREFIX + 'CREATE_GALLERY_IN_VIEW_LIST';
exports.VIEW_LIST_CREATE_GANTT_VIEW = PREFIX + 'CREATE_GANTT_IN_VIEW_LIST';
exports.CREATE_CALENDAR_IN_VIEW_LIST = PREFIX + 'CREATE_CALENDAR_IN_VIEW_LIST';
exports.CREATE_ORG_IN_VIEW_LIST = PREFIX + 'CREATE_ORG_IN_VIEW_LIST';
// floating frame
exports.APPLICATION_JOIN_SPACE_BTN = PREFIX + 'APPLICATION_JOIN_SPACE_BTN';
exports.ADD_RECORD_BTN = PREFIX + 'ADD_RECORD_BTN';
// magic form
exports.FORM_CONTAINER_SETTING = PREFIX + 'FORM_CONTAINER_SETTING'; // Magical form content page - setting button
// Gantt chart
exports.GANTT_CONFIG_COLOR_HELP = PREFIX + 'GANTT_CONFIG_COLOR_HELP';
// Organization Chart
exports.ORG_CHART_RECORD_LIST = PREFIX + 'ORG_CHART_RECORD_LIST'; // Organization Chart - Record List
// toolbar
exports.TOOL_BAR_VIEW_SETTING = PREFIX + 'TOOL_BAR_VIEW_SETTING'; // Toolbar - new record
// side record card
exports.SIDE_RECORD_PANEL = PREFIX + 'SIDE_RECORD_PANEL';
//# sourceMappingURL=datasheet_id.js.map